import CryptoJS from 'crypto-js';

// Secret key from environment variable (with fallback matching backend)
const cleanSecret = (process.env.REACT_APP_SECRET_KEY || '')
  .replace(/['"]/g, '')
  .trim();
const SECRET_KEY =
  cleanSecret ||
  '2pgygl4awugdwaam0vvpw3n6bvhofabnxscle8jwj9odm4rbpr9fyqd7vy31tfgd';

/**
 * Deterministically sorts object keys and converts to string
 */
export function canonicalizeData(data) {
  if (data === undefined) return undefined;
  if (data === null) return 'null';
  if (typeof data !== 'object') return JSON.stringify(data);
  if (Array.isArray(data)) {
    return '[' + data.map((value) => canonicalizeData(value) ?? 'null').join(',') + ']';
  }
  // JSON.stringify omits undefined/function/symbol object properties. Match
  // that behavior so the signed body matches the JSON Axios actually sends.
  const keys = Object.keys(data)
    .filter((key) => {
      const value = data[key];
      return value !== undefined && typeof value !== 'function' && typeof value !== 'symbol';
    })
    .sort();
  const parts = keys.map(
    (key) => JSON.stringify(key) + ':' + canonicalizeData(data[key])
  );
  return '{' + parts.join(',') + '}';
}

/**
 * Generates HMAC signature and timestamp headers for an API request
 * @param {Object} params
 * @param {string} params.method - HTTP method (GET, POST, etc.)
 * @param {string} params.endpoint - API endpoint path (e.g. 'me', 'admin/login', 'list?page=1')
 * @param {any} params.data - Request body or FormData
 * @returns {{ 'x-hmac-signature': string, 'x-hmac-timestamp': string }}
 */
export function generateHmacHeaders({ method = 'GET', endpoint = '', data = null }) {
  const timestamp = Date.now().toString();
  const normMethod = (method || 'GET').toUpperCase();
  const normalizedPath =
    '/' +
    String(endpoint || '')
      .split('?')[0]
      .replace(/^\/+/, '')
      .replace(/\/+$/, '');

  let serializedPayload = '';
  const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;

  if (isFormData) {
    serializedPayload = 'MULTIPART_FORM_DATA';
  } else if (data && typeof data === 'object' && Object.keys(data).length > 0) {
    serializedPayload = canonicalizeData(data);
  } else if (typeof endpoint === 'string' && endpoint.includes('?')) {
    const qs = endpoint.slice(endpoint.indexOf('?') + 1);
    if (qs) {
      const params = new URLSearchParams(qs);
      const keys = Array.from(params.keys()).filter(Boolean).sort();
      serializedPayload = keys.map((k) => `${k}=${params.get(k)}`).join('&');
    }
  }

  const signString = `${normMethod}:${normalizedPath}:${timestamp}:${serializedPayload}`;
  const signature = CryptoJS.HmacSHA256(signString, SECRET_KEY).toString(CryptoJS.enc.Hex);

  return {
    'x-hmac-signature': signature,
    'x-hmac-timestamp': timestamp,
  };
}

// Backward compatibility export
export function createNewHmac(data) {
  return generateHmacHeaders({ method: 'POST', endpoint: '', data })['x-hmac-signature'];
}
